module.exports = __webpack_public_path__ + "static/img/logo13.475f94a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link2/logo13.jpg
// module id = mbBl
// module chunks = 1